import React from 'react'
import { IconWrapper } from '../IconWrapper'
import type { IconWrapperProps } from '../IconWrapper'

export const SixDotsVerticalIcon = React.forwardRef<SVGSVGElement, IconWrapperProps>(
  (props, forwardedRef) => {
    return (
      <IconWrapper {...props}>
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          {...props}
          ref={forwardedRef}
        >
          <path
            d="M8.5 17C9.32843 17 10 17.6716 10 18.5 10 19.3284 9.32843 20 8.5 20 7.67157 20 7 19.3284 7 18.5 7 17.6716 7.67157 17 8.5 17zM8.5 11C9.32843 11 10 11.6716 10 12.5 10 13.3284 9.32843 14 8.5 14 7.67157 14 7 13.3284 7 12.5 7 11.6716 7.67157 11 8.5 11zM8.5 5C9.32843 5 10 5.67157 10 6.5 10 7.32843 9.32843 8 8.5 8 7.67157 8 7 7.32843 7 6.5 7 5.67157 7.67157 5 8.5 5zM15.5 17C16.3284 17 17 17.6716 17 18.5 17 19.3284 16.3284 20 15.5 20 14.6716 20 14 19.3284 14 18.5 14 17.6716 14.6716 17 15.5 17zM15.5 11C16.3284 11 17 11.6716 17 12.5 17 13.3284 16.3284 14 15.5 14 14.6716 14 14 13.3284 14 12.5 14 11.6716 14.6716 11 15.5 11zM15.5 5C16.3284 5 17 5.67157 17 6.5 17 7.32843 16.3284 8 15.5 8 14.6716 8 14 7.32843 14 6.5 14 5.67157 14.6716 5 15.5 5z"
            fill="#222"
          />
        </svg>
      </IconWrapper>
    )
  },
)
